export default __webpack_public_path__ + "static/media/icon-add.c3267605.svg";